export enum DigitalSignStepEnum {
  STEP_COMPANY = "Nimber",
  STEP_EMPLOYEE = "Colaborador",
}
